export function isError(err: Error | unknown): err is Error {
  return (err as Error).message !== undefined;
}

export function isAxiosError(err: unknown): err is { response?: { data?: { messages?: string[] } }; message?: string } {
  return typeof err === 'object' && err !== null && 'response' in err;
}

export const buildErrorMessage = (
  err: Error | unknown,
  defaultMessage = "Erro ao executar ação"
) => {
  // Primeiro tenta pegar mensagens da resposta da API (AxiosError)
  if (isAxiosError(err) && err.response?.data?.messages) {
    const messages = err.response.data.messages;
    if (Array.isArray(messages) && messages.length > 0) {
      // Se houver múltiplas mensagens, concatená-las
      return messages.join(". ");
    }
  }
  
  // Fallback para mensagem do erro padrão
  const messagesArray: string[] = isError(err)
    ? [err.message]
    : [defaultMessage];

  const message = messagesArray[0];

  return message;
};
